export const movement = [
  { id: 1, label: 'Secondary' },
  { id: 2, label: 'Primary' },
  { id: 3, label: 'Vendor' },
  { id: 4, label: 'Return' },
];

export const movementKeys = {
  1: 'SECONDARY',
  2: 'PRIMARY',
};

export const movementLabels = {
  1: {
    label: 'All Consignees',
    short_code: 'S',
  },
  2: {
    tlabel: 'MDM_ALL_DEPOTS',
    short_code: 'P',
  },
  3: {
    label: 'All Vendors',
    short_code: 'V',
  },
  4: {
    label: 'All Return Consignees',
    short_code: 'R',
  },
};

export const defaultSettings = {
  max_split: null,
  split_factor: null,
  ftl_certify: null,
  algorithm: null,
  degree_of_deviation: null,
  optima_type: null,
  vehicle_exclusion: [],
  vehicle_constraining_factor: [],
  default_constraining_factor: { weight: 1, volume: 1 },
  gate_pickup_threshold: [],
  material_categories: [],
  mode: null,
  max_pickup_points: null,
  fitment: null,
  max_drop_points: null,
  extra_drop_charges: null,
  drop_off_rule: [],
  pickup_threshold: { weight: 5000, volume: 400 },
  floor_one: { weight: 3000, volume: 363 },
  floor_two: { weight: 90, volume: 90 },
  telescopic_threshold: { weight: 0, volume: 0 },
};

export const menuOptions = [{
  id: '',
  name: 'Optima',
  permission: 'optima_view_indent',
}, {
  id: 'constraints',
  name: 'Constraints',
  permission: 'optima_settings',
}];

export const algorithmTypes = [
  { id: 1, name: 'Default' },
  { id: 2, name: 'Custom' },
  { id: 3, name: 'FDP' },
  { id: 4, name: 'Courier' },
  { id: 5, name: 'Multi Pick FDP' },
];

export const algorithmNameTypes = {
  Default: 1,
  Custom: 2,
  FDP: 3,
  Courier: 4,
  'Multi Pick FDP': 5,
};

export const optimaType = [
  { id: 1, name: '2D' },
  { id: 2, name: 'LBH' },
  { id: 3, name: 'TELESCOPIC' },
  { id: 4, name: 'DELIVERY_WINDOW' },
];

export const optimaNameType = {
  '2D': 1,
  LBH: 2,
  TELESCOPIC: 3,
  DELIVERY_WINDOW: 4,
};

export const ptlContracts = [{
  id: 0,
  name: 'Disable / Reject',
},
{
  id: 1,
  name: 'Auto',
},
{
  id: 2,
  name: 'Courier',
}];


export const limitedTruckCountList = [
  { id: 1, name: 'Yes', value: true },
  { id: 2, name: 'No', value: false },
];

export const deliveryPickStatus = [
  { id: 1, label: 'Pending' },
  // { id: 2, label: 'Processing' },
  { id: 3, label: 'Completed' },
  // { id: 4, label: 'Failed' }
];

export const optimaSplitCombileReasons = [
  { id: 1, name: 'Vehicle type unavailable' },
  { id: 2, name: 'Vehicle type cannot access consignee location' },
  { id: 3, name: 'Cannot combine consignee(s)' },
  { id: 4, name: 'Too many delivery splits (leading to multiple invoices)' },
  { id: 5, name: 'A larger truck is available for upsizing and dispatching' },
  { id: 6, name: 'The transporter has not responded to the request.' },
  { id: 7, name: 'Other' },
];

export const optimaEditReasons = [
  { id: 1, name: 'Vehicle type not available with transporter' },
  { id: 2, name: 'No response from Transporter' },
  { id: 3, name: 'Other' },
];

export const optimaSearchConstants = [
  {
    id: 1,
    name: 'delivery_number',
    query: 'delivery_number',
    tname: 'S_OPTIMA_DELIVERY_NUMBER',
    multiple: true,
    multiValue: true,
    infoTooltip: 'Multiple inputs allowed, separated by commas',
  },
  {
    id: 2,
    name: 'pickup',
    query: 'pickup',
    tname: 'OPTIMA_PICK_UP_NAME',
    placeholder: 'Pickup',
  },
  {
    id: 3,
    name: 'Ship-To',
    query: 'shipTo',
    tname: 'OPTIMA_SHIP_TO',
    placeholder: 'Ship-To',
  },
  {
    id: 4,
    name: 'Sold-To',
    query: 'soldTo',
    tname: 'OPTIMA_SOLD_TO',
    placeholder: 'Sold-To',
  },
  {
    id: 5,
    name: 'transporter',
    query: 'transporter',
    currentQuerySelected: 'transporter_name',
    tname: 'OPTIMA_TRANSPORTER',
    multiDropDownQueryOptions: [
      {
        label: 'in Name',
        tlabel: 'INDENT_IN_NAME',
        typeLabel: 'Name',
        ttypeLabel: 'INDENT_NAME',
        name: 'Transporter Name',
        tname: 'INDENT_TRANSPORTER_NAME',
        query: 'transporter_name',
      },
      {
        label: 'in Ref id',
        tlabel: 'INDENT_IN_REF_ID',
        typeLabel: 'Ref id',
        ttypeLabel: 'INDENT_REF_ID',
        name: 'Transporter Ref id',
        tname: 'INDENT_TRANSPORTER_REF_ID',
        query: 'transporter_ref_id',
      },
    ],
  },
  {
    id: 6,
    name: 'material_code',
    query: 'material_code',
    tname: 'S_OPTIMA_MATERIAL_CODE',
    multiple: true,
    multiValue: true,
    infoTooltip: 'Multiple inputs allowed, separated by commas',
  },
  {
    id: 7,
    name: 'destination_city',
    query: 'destination_city',
    tname: 'S_OPTIMA_DESTINATION_CITY',
  },
  {
    id: 8,
    name: 'category_priority',
    query: 'category_priority',
    tname: 'S_OPTIMA_CATEGORY_PRIORITY',
  },
  {
    id: 9,
    name: 'vehicle_mode',
    query: 'vehicle_mode',
    tname: 'S_OPTIMA_VEHICLE_MODE',
  },
  {
    id: 10,
    name: 'truck_type',
    query: 'truck_type',
    tname: 'S_OPTIMA_TRUCK_TYPE',
  },
  {
    id: 11,
    name: 'material_category',
    query: 'material_category',
    tname: 'S_OPTIMA_MATERIAL_CATEGORY',
  },
  {
    id: 12,
    name: 'destination_region',
    query: 'ship_to_region',
    tname: 'OPTIMA_DESTINATION_REGION',
  },
];

export const optimaDeliveryProcess = [
  {
    id: 'process',
    tlabel: 'OPTIMA_DN_PROCESSED',
    color: 'text-linear-green',
    disable_cursor: false,
  },
  {
    id: 'erpRejections',
    tlabel: 'OPTIMA_PICKLIST_REJECTIONS',
    color: 'text-linear-red',
    disable_cursor: false,
  },
  {
    id: 'rejected',
    tlabel: 'OPTIMA_OPTIMA_REJECTION',
    color: 'text-linear-red',
    disable_cursor: false,
  },
  {
    id: 'indent_count',
    tlabel: 'OPTIMA_COUNT',
    color: '',
    disable_cursor: true,
  },
];

export const optimaListHeaders = [
  { id: 0, title: 'Name', tlabel: 'OPTIMA_S_NO', colSpan: 1, column: 'order_number', truncateOn: 20, show: true, wrapContainer: false, utilization: false },
  { id: 1, title: 'Total picks and drops', tlabel: 'Total picks and drops', colSpan: 4, column: 'total_picks_drops', truncateOn: 20, show: true, wrapContainer: false, utilization: false, sortable: true },
  { id: 2, title: 'pickup', tlabel: 'OPTIMA_PICK_UP_NAME', colSpan: 4, column: 'gate_name', truncateOn: 20, show: false, wrapContainer: true, utilization: false },
  { id: 3, title: 'pickup_name', tlabel: 'OPTIMA_PICK_UPS', colSpan: 4, column: 'gate_reference_id', truncateOn: 20, show: true, wrapContainer: true, utilization: false },
  { id: 4, title: 'Ship to', tlabel: 'OPTIMA_DROP_OFF_NAME', colSpan: 4, column: 'name', truncateOn: 20, show: false, wrapContainer: true, utilization: false },
  { id: 5, title: 'ref_id', tlabel: 'OPTIMA_REF_ID', colSpan: 4, column: 'reference_id', truncateOn: 12, show: true, wrapContainer: true, utilization: false },
  { id: 6, title: 'Sold to', tlabel: 'OPTIMA_SOLD_TO_NAME', colSpan: 4, path: 'sold_to.name', column: 'sold_to_name', truncateOn: 20, show: false, wrapContainer: true, utilization: false },
  { id: 7, title: 'Sold to ref_id', tlabel: 'OPTIMA_SOLD_TO_REF', colSpan: 4, path: 'sold_to.reference_id', column: 'sold_to_reference_id', truncateOn: 12, show: true, wrapContainer: true, utilization: false },
  { id: 8, title: 'city', tlabel: 'OPTIMA_CITY', colSpan: 4, column: 'city', show: false, truncateOn: 12, wrapContainer: true, utilization: false },
  { id: 9, title: 'transporter', tlabel: 'Transporter Name', path: 'transporter.name', colSpan: 5, column: 'transporter', truncateOn: 22, show: true, wrapContainer: false, utilization: false },
  { id: 10, title: 'total_weight', tlabel: 'Wt(KG)| Wt%', colSpan: 3, column: 'total_weight', truncateOn: 22, show: true, wrapContainer: false, utilization: false, sortable: true },
  { id: 11, title: 'total_volume', tlabel: 'OPTIMA_VOL', colSpan: 3, column: 'total_volume', truncateOn: 22, show: true, wrapContainer: false, utilization: false, sortable: true },
  { id: 12, title: 'total_quantity', tlabel: 'OPTIMA_QTY', colSpan: 3, column: 'total_quantity', truncateOn: 22, show: true, wrapContainer: false, utilization: false, sortable: true },
  { id: 13, title: 'vehicle_type', tlabel: 'OPTIMA_VEHICLE_DETAILS', colSpan: 6, path: 'vehicle_type.name', column: 'vehicle_type', truncateOn: 22, show: true, wrapContainer: false, utilization: false },
  { id: 14, title: 'category_priority', tlabel: 'OPTIMA_CATEGORY_PRIORITY', colSpan: 6, path: 'category_priority.priority', column: 'category_priority', truncateOn: 22, show: false, wrapContainer: false, utilization: false, date: false, sortable: true },
  { id: 15, title: 'delivery_date', tlabel: 'S_OPTIMA_CREATED_AT', colSpan: 6, column: 'delivery_date', truncateOn: 22, show: false, wrapContainer: false, utilization: false, date: true, sortable: true },
  { id: 16, title: 'vehicle_requirement_date', tlabel: 'OPTIMA_VEHICLE_REQUIREMENT_DATE', colSpan: 8, column: 'vehicle_requirement_date', truncateOn: 22, show: false, wrapContainer: false, utilization: false, date: true, sortable: true },
  { id: 17, title: 'cost', tlabel: 'OPTIMA_COST', colSpan: 8, column: 'cost', truncateOn: 22, show: false, wrapContainer: false, utilization: false, date: false, sortable: true },
  { id: 18, title: 'inv_amount', tlabel: 'OPTIMA_INVOICE_AMOUNT', colSpan: 8, column: 'inv_amount', truncateOn: 22, show: false, wrapContainer: false, utilization: false, date: false, sortable: true },
  { id: 19, title: 'mrp', tlabel: 'OPTIMA_MRP', colSpan: 8, column: 'mrp', truncateOn: 22, show: false, wrapContainer: false, utilization: false, date: false, sortable: true },
  { id: 20, title: 'freight_by_sales_percent', tlabel: 'OPTIMA_FREIGHT_BY_SALES_PERCENT', colSpan: 8, column: 'freight_by_sales_percent', truncateOn: 22, show: false, wrapContainer: false, utilization: false, date: false, sortable: true },
  { id: 21, title: 'freight_by_mrp_percent', tlabel: 'OPTIMA_FREIGHT_BY_MRP_PERCENT', colSpan: 8, column: 'freight_by_mrp_percent', truncateOn: 22, show: false, wrapContainer: false, utilization: false, date: false, sortable: true },
  { id: 22, title: 'bin_count', tlabel: 'OPTIMA_BIN_COUNT', colSpan: 8, column: 'bin_count', truncateOn: 22, show: false, wrapContainer: false, utilization: false, date: false },
  { id: 23, title: 'pallet_count', tlabel: 'OPTIMA_PALLET_COUNT', colSpan: 8, column: 'pallet_count', truncateOn: 22, show: false, wrapContainer: false, utilization: false, date: false},
  { id: 24, title: 'bin_pallet_ratio', tlabel: 'OPTIMA_BIN_PALLET_RATIO', colSpan: 8, column: 'bin_pallet_ratio', truncateOn: 22, show: false, wrapContainer: false, utilization: false, date: false},
  { id: 25, title: 'box_count', tlabel: 'OPTIMA_BOX_COUNT', colSpan: 8, column: 'box_count', truncateOn: 22, show: false, wrapContainer: false, utilization: false, date: false},
  { id: 26, title: 'trolley_count', tlabel: 'OPTIMA_TROLLEY_COUNT', colSpan: 8, column: 'trolley_count', truncateOn: 22, show: false, wrapContainer: false, utilization: false, date: false},
  { id: 27, title: 'box_trolley_ratio', tlabel: 'OPTIMA_BOX_TROLLEY_RATIO', colSpan: 8, column: 'box_trolley_ratio', truncateOn: 22, show: false, wrapContainer: false, utilization: false, date: false},
  { id: 28, title: 'truck_in_time', tlabel: 'OPTIMA_EARLIEST_TRUCK_TIME', colSpan: 8, column: 'truck_in_time', truncateOn: 22, show: false, wrapContainer: false, utilization: false, date: true, sortable: false },
  { id: 29, title: 'existing_indent_consignees', tlabel: 'OPTIMA_EXISTING_INDENT_TOPUP_CUSTOMERS', colSpan: 8, column: 'existing_indent_consignees', truncateOn: 22, show: false, wrapContainer: false, utilization: false },
  { id: 30, title: 'vehicle_number', tlabel: 'OPTIMA_VEHICLE_NUMBER', colSpan: 6, path: 'vehicle_type.number', column: 'vehicle_number', truncateOn: 22, show: false, wrapContainer: false, utilization: false },
  { id: 31, title: 'transit_days', tlabel: 'OPTIMA_TRANSIT_DAYS', colSpan: 8, column: 'transit_days', truncateOn: 22, show: false, wrapContainer: false, utilization: false },
  { id: 32, title: 'expected_delivery_date', tlabel: 'OPTIMA_EXPECTED_DELIVERY_DATE', colSpan: 8, column: 'expected_delivery_date', truncateOn: 22, show: false, wrapContainer: false, utilization: false, date: false, sortable: true },
  { id: 33, title: 'plan_expiry_date', tlabel: 'OPTIMA_PLAN_EXPIRY_DATE', colSpan: 8, column: 'plan_expiry_date', truncateOn: 22, show: false, wrapContainer: false, utilization: false, date: false, sortable: true },
  { id: 34, title: 'dispatch_date', tlabel: 'OPTIMA_DISPATCH_DATE', colSpan: 8, column: 'dispatch_date', truncateOn: 22, show: false, wrapContainer: false, utilization: false, date: false, sortable: true },
  { id: 34, title: 'remaining_weight', tlabel: 'OPTIMA_REMAINING_WEIGHT', colSpan: 8, column: 'remaining_weight', truncateOn: 22, show: false, wrapContainer: false, utilization: false, date: false, sortable: true },
  { id: 35, title: 'remaining_volume', tlabel: 'OPTIMA_REMAINING_VOLUME', colSpan: 8, column: 'remaining_volume', truncateOn: 22, show: false, wrapContainer: false, utilization: false, date: false, sortable: true },
  { id: 36, title: 'remaining_capacity_in_cases', tlabel: 'OPTIMA_REMAINING_CAPACITY_IN_CASES', colSpan: 8, column: 'remaining_capacity_in_cases', truncateOn: 22, show: false, wrapContainer: false, utilization: false, date: false, sortable: true },
  { id: 37, title: 'alternate_required_capacity_in_cases', tlabel: 'OPTIMA_ALTERNATE_REQUIRED_CAPACITY_IN_CASES', colSpan: 8, column: 'alternate_required_capacity_in_cases', truncateOn: 22, show: false, wrapContainer: false, utilization: false, date: false, sortable: true },
  // { id: 38, title: 'material_category', tlabel: 'OPTIMA_MATERIAL_CATEGORY', colSpan: 8, column: 'material_category', truncateOn: 22, show: false, wrapContainer: false, utilization: false, date: false, sortable: false },
  { id: 38, title: 'Ageing', tlabel: 'OPTIMA_AGEING', colSpan: 4, column: 'ageing', truncateOn: 20, show: false, wrapContainer: false, utilization: false, sortable: true, sortLabel: 'ageing' },
  { id: 39, title: 'Last Dispatch Date', tlabel: 'OPTIMA_LAST_DISPATCH_DATE', colSpan: 4, column: 'last_dispatch_date', truncateOn: 20, show: false, wrapContainer: false, utilization: false, sortable: true, sortLabel: 'last_dispatch_date' },
  { id: 40, title: 'Region', tlabel: 'OPTIMA_REGION', colSpan: 4, column: 'ship_to_region', truncateOn: 20, show: false, wrapContainer: true, utilization: false, sortable: true, sortLabel: 'ship_to_region_sort' },
  { id: 41, title: 'Customer Category', tlabel: 'OPTIMA_CUSTOMER_CATEGORY', colSpan: 4, column: 'category', truncateOn: 20, show: false, wrapContainer: false, utilization: false, sortable: true, sortLabel: 'category_sort' },
];

export const optimaInputListHeaders = [
  { id: 0, title: 'S No', tlabel: 'OPTIMA_S_NO', colSpan: 4, column: 's_no', truncateOn: 20, show: true, wrapContainer: true, utilization: false, sortLabel: '' },
  { id: 1, title: 'Ship-To Name', tlabel: 'OPTIMA_SHIP_TO_NAME', colSpan: 4, column: 'consignee.name', path: 'consignee.name', truncateOn: 20, show: false, wrapContainer: true, utilization: false,sortable: true, sortLabel: 'consignee_name' },
  { id: 2, title: 'Ship-To Ref-Id', tlabel: 'OPTIMA_SHIP_TO_REF_ID', colSpan: 4, column: 'consignee.ref_id', path: 'consignee.ref_id', truncateOn: 20, show: true, wrapContainer: true, utilization: false, sortable: true, sortLabel: '_id.consignee_ref_id' },
  { id: 11, title: 'Ship-To City', tlabel: 'OPTIMA_SHIP_TO_CITY', colSpan: 4, column: 'consignee.destination', path: 'consignee.destination', show: false, truncateOn: 12, wrapContainer: true, utilization: false,sortable: true, sortLabel: 'consignee_destination' },
  { id: 17, title: 'Ship-To Pincode', tlabel: 'OPTIMA_PINCODE', colSpan: 4, column: 'consignee.pincode', path: 'consignee.pincode', truncateOn: 20, show: false, wrapContainer: true, utilization: false, sortable: true, sortLabel: 'consignee_pincode' },
  { id: 3, title: 'Sold To', tlabel: 'OPTIMA_SOLD_TO_NAMES', colSpan: 4, column: 'sold_to_names', truncateOn: 20, show: false, wrapContainer: true, utilization: false, sortLabel: '' },
  { id: 4, title: 'Sold To Ref Id', tlabel: 'OPTIMA_SOLD_TO_REF_IDS', colSpan: 4, column: 'sold_to_ref_ids', truncateOn: 12, show: true, wrapContainer: true, utilization: false, sortable: true, sortLabel: 'sold_to_ref_ids' },
  { id: 5, title: 'Pickup Gate', tlabel: 'OPTIMA_PICKUP_NAMES', colSpan: 4, path: 'pickup_gate_names', column: 'sold_to_name', truncateOn: 20, show: true, wrapContainer: true, utilization: false, sortLabel: '' },
  { id: 6, title: 'Pickup Gate Ref Id', tlabel: 'OPTIMA_PICKUP_REF_ID', colSpan: 4, path: 'pickup_gate_ref_ids', column: 'sold_to_reference_id', truncateOn: 12, show: true, wrapContainer: true, utilization: false, sortable: true, sortLabel: 'pickup_gate_ref_ids' },
  { id: 7, title: 'Delivery Number(s)', tlabel: 'OPTIMA_DELIVERY_NUMBERS', colSpan: 4, column: 'delivery_number', show: false, truncateOn: 12, wrapContainer: true, utilization: false, sortable: true, sortLabel: 'delivery_number' },
  { id: 8, title: 'Material Codes(s)', tlabel: 'OPTIMA_MATERIAL_CODES', colSpan: 4, column: 'material_code', show: false, truncateOn: 12, wrapContainer: true, utilization: false, sortable: true, sortLabel: 'material_code' },
  { id: 9, title: 'Total Weight', tlabel: 'OPTIMA_TOTAL_WEIGHT', colSpan: 4, column: 'weight', show: false, truncateOn: 12, wrapContainer: true, utilization: false, sortable: true, sortLabel: 'weight' },
  { id: 10, title: 'Total Volume', tlabel: 'OPTIMA_TOTAL_VOLUME', colSpan: 4, column: 'volume', show: false, truncateOn: 12, wrapContainer: true, utilization: false, sortable: true, sortLabel: 'volume' },
  { id: 11, title: 'Total Quantity', tlabel: 'OPTIMA_TOTAL_QUANTITY', colSpan: 4, column: 'quantity', show: false, truncateOn: 12, wrapContainer: true, utilization: false, sortable: true, sortLabel: 'quantity' },
  { id: 12, title: 'Material Category', tlabel: 'OPTIMA_MATERIAL_CATEGORY', colSpan: 4, column: 'category', show: false, truncateOn: 12, wrapContainer: true, utilization: false, sortable: true, sortLabel: 'category' },
  { id: 13, title: 'Remarks', tlabel: 'OPTIMA_REMARKS', colSpan: 4, column: 'remarks', show: false, truncateOn: 12, wrapContainer: true, utilization: false, sortLabel: '' },
  { id: 14, title: 'Vehicle Requirement Date', tlabel: 'OPTIMA_INPUT_LISTING_VEHICLE_REQUIREMENT_DATE', colSpan: 4, column: 'vehicle_requirement_date', show: false, truncateOn: 25, wrapContainer: true, utilization: false, date: true, sortable: true, sortLabel: 'vehicle_requirement_date' },
  { id: 15, title: 'Ship Ready Date', tlabel: 'OPTIMA_SHIP_READY_DATE', colSpan: 4, column: 'ship_ready_date', show: false, truncateOn: 25, wrapContainer: true, utilization: false, date: false, sortable: true, sortLabel: 'ship_ready_date' },
  { id: 16, title: 'Delivery Date', tlabel: 'OPTIMA_DELIVERY_DATE', colSpan: 4, column: 'delivery_date', truncateOn: 20, show: true, wrapContainer: true, utilization: false, sortable: true, sortLabel: 'delivery_date' },
  { id: 17, title: 'Delivery Aging', tlabel: 'OPTIMA_DELIVERY_AGING', colSpan: 4, column: 'delivery_aging', truncateOn: 12, show: false, wrapContainer: false, utilization: false, sortable: true, sortLabel: 'delivery_aging', featureFlag: 'optima_delivery_aging' },
];

export const optimaInputSearchConstants = [
  {
    id: 1,
    name: 'customer_ref_id',
    query: 'customer_ref_id',
    tname: 'S_OPTIMA_CONSIGNEE',
  },
  {
    id: 2,
    name: 'delivery_number',
    query: 'delivery_number',
    tname: 'S_OPTIMA_DELIVERY_NUMBER',
    multiple: true,
    multiValue: true,
    infoTooltip: 'Multiple inputs allowed, separated by commas',
  },
  {
    id: 3,
    name: 'material_ref_id',
    query: 'material_ref_id',
    tname: 'S_OPTIMA_MATERIAL_CODE',
    multiple: true,
    multiValue: true,
    infoTooltip: 'Multiple inputs allowed, separated by commas',
  },
  {
    id: 4,
    name: 'destination_city',
    query: 'destination_city',
    tname: 'S_OPTIMA_DESTINATION_CITY',
  },
];

export const optimaInputSource = {
  ERP: 1,
  UPLOAD: 2,
};

export const optimaInputConsigneeFilter = {
  PENDING: 1,
  COMPLETED: 3,
  HOLD: 7,
  ALL_DEPOT: 8,
  CANCEL:9,
  EXPIRED: 10,
};

export const optimaAdminReasonTypes = {
  OPTIMA_EDIT_TYPE: 'OPTIMA_EDIT',
  OPTIMA_COMBINE_TYPE: 'OPTIMA_COMBINE',
  OPTIMA_SPLIT_TYPE: 'OPTIMA_SPLIT',
};

export const rejectionsFilterList = [
  {
    id: 0,
    tlabel: 'ALL',
    value: 'all',
  },
  {
    id: 1,
    tlabel: 'OPTIMA_PRE_OPTIMA',
    value: 'PRE_OPTIMA_STAGE',
  },
  {
    id: 2,
    tlabel: 'OPTIMA_POST_OPTIMA',
    value: 'POST_OPTIMA_STAGE',
  },
  {
    id: 3,
    tlabel: 'OPTIMA_PICKLIST',
    value: 'DELIVERY_PICKLIST_STAGE',
  },
];

export const quantityUnits = ['c/s', 's/o', 'cs', 'box', 'boxes', 'pkg', 'mt',
  'pkgs', 'cases', 'case', 'nos', 'pce', 'no', 'pcs', 'bags', 'each', 'ea', 'kar', 'ctn', 'st', 'ltr',
  'lt', 'liter', 'litre', 'litres', 'ltrs', 'liters', 'kg', 'kgs', 'pc', 'PC', 'CV', 'cv', 'PAC', 'pac'];

export const movementPermissionSuffix = {
  1: 'secondary',
  2: 'primary',
  3: 'vendor',
  4: 'return',
};

export { movement as default };
